<template>
  <a-modal title="选择销售订单" class="sales-order-modal" :visible="visible" @ok="onCofrim" @cancel="handleCancel">
    <div>
      <a-table :loading="{  spinning: $store.state.tabLoding, indicator:indicator }" :columns="columns" :dataSource="dataSource" :pagination="false" bordered @change="handleTableChange" :scroll="{y: 420 }" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,getCheckboxProps:getCheckboxProps }">
        <template slot="name" slot-scope="text, record">
          <div class="table-name"><img v-if="record.assemblyFlag == 1" src="@/assets/image/manage_zong@2x.png" />{{record.name}}</div>
        </template>
        <template slot="operation" slot-scope="text, record">
          <img src="@/assets/image/changyong@2x(1).png" style="width: 18px" v-if="record.commonlyUsedFlag == 0" @click="onCollection(record,1)" />
          <img src="@/assets/image/changyong@2x.png" style="width: 18px" v-else @click="onCollection(record,2)" />
        </template>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import { getListMethod } from "@/utils/api"
export default {
  name: 'salesOrder',
  components: {

  },
  data () {
    return {
      visible: false,
      //   ipagination: {
      //     current: 1,
      //     pageSize: 10,
      //     showTotal: (total, range) => {
      //       return range[0] + "-" + range[1] + " 共" + total + "条"
      //     },
      //     showQuickJumper: true,
      //     showSizeChanger: true,
      //     total: 100
      //   },
      columns: [
        {
          title: '单据编号',
          dataIndex: 'code',
          key: 'code',
        }, {
          title: '单据日期',
          dataIndex: 'voucherDate',
          key: 'voucherDate',
        }, {
          title: '购货单位',
          dataIndex: 'contactCustomerName',
          key: 'contactCustomerName',
        }, {
          title: '经办人',
          dataIndex: 'transactorName',
          key: 'transactorName',
        }, {
          title: '单据金额',
          dataIndex: 'totalAmount',
          key: 'totalAmount',
        }, {
          title: '摘要',
          dataIndex: 'digest',
          key: 'digest',
        }
      ],
      selectedRowKeys: [],
      selectedRow: [],
      dataSource: [],
      contactCustomerId: '',
      urlList: {
        list: '/order/api/salesOrder/listNoSettlementSalesOrder',
        glist: '/order/api/salesOrder/listSalesOrderItemBySalesOrderIdList'
      },
      voucherId: [],
      goodsList: [],
      selectVoucherId: [],
      isLoding: false,
      indicator: <a-icon type="loading" style="font-size: 24px" spin />
    }
  },
  methods: {
    open (contactCustomerId, selectVoucherId) {
      console.log(selectVoucherId)
      this.visible = true
      this.selectedRowKeys = []
      this.selectedRow = []
      this.selectVoucherId = selectVoucherId
      this.contactCustomerId = contactCustomerId
      this.getGoodsList()
    },
    handleCancel () {
      this.visible = false
    },
    onSelectChange (selectedRowKeys, selectedRow) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRow = selectedRow
      this.voucherId = []
      this.selectedRow.map(item => {
        this.voucherId.push(item.id)
      })
      this.getOrderGoodsList()
    },
    getCheckboxProps (record) {
      return ({
        props: {
          disabled: this.selectVoucherId.some(item => item === record.id)
        }
      })
    },
    handleTableChange (e) {
      console.log(e)
    },
    onCofrim () {
      this.visible = false
      this.$emit('salesConfirm', this.goodsList, this.voucherId)
    },
    // 获取表格数据
    getGoodsList () {
      this.$store.state.tabLoding = true
      let url = this.urlList.list
      let params = {
        companyStoreId: this.$store.state.userInfo.companyStoreId,
        contactCustomerId: this.contactCustomerId
      }
      getListMethod(url, params).then((res) => {
        if (res.success) {
          this.$store.state.tabLoding = false
          this.dataSource = res.result
          console.log(this.dataSource)
        }
      })
    },
    // 获取单据商品
    getOrderGoodsList () {
      let url = this.urlList.glist
      let data = {
        companyStoreId: this.$store.state.userInfo.companyStoreId
      }
      let params = this.voucherId
      getListMethod(url, params, {}, data).then((res) => {
        if (res.success) {
          this.goodsList = res.result
          this.goodsList.map(item => {
            item.businessVoucherId = item.salesOrderId
            item.businessVoucherCode = item.salesOrderCode
          })
        }
      })
    }
  },
  watch: {

  }
}
</script>
<style lang="scss">
.sales-order-modal {
  width: 1085px !important;
  // height: 675px !important;
  .ant-modal-body {
    padding: 0 24px 24px 24px !important;
    .ant-table-tbody {
      td {
        background: #ffffff !important;
      }
    }
  }
  .ant-table-wrapper {
    border: 1px solid #f0f0f0;
    border-bottom: 0;
  }
  .ant-modal-footer {
    padding: 0 0 30px 0;
  }
}
</style>
